class PurchaseController {
  constructor(NumberService) {
    this.name = 'purchase';
    this.NumberService = NumberService;
    this.matterType = 'real_estate_purchase';
    this.stepSelector = 'purchase-steps';
    this.pages = [
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'PRICE AND DEPOSIT',
        fields: [
          {
            fieldName: 'Purchase Price',
            field: 'price',
            type:'currency',
            required: true,
            value: "0.00",
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'price');
              // valid when price is defined and it is greater than 55000
              return typeof x.value !== 'undefined' && this.NumberService.parseDecimal(x.value) >= 55000;
            },
            invalidText: 'Purchase Price must be greater than $55,000.00'
          },
          {
            fieldName: 'Deposit Paid',
            field: 'deposit',
            type:'currency',
            required: false,
            value: "0.00",
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'price');
              let y = fields.find(x => x.field === 'deposit');
              // valid if the deposit is not greater than the price
              return this.NumberService.parseDecimal(x.value ? x.value : '') >= this.NumberService.parseDecimal(y.value ? y.value : '');
            },
            invalidText: 'Deposit cannot be greater than the purchase price'
          },
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'MORTGAGE',
        fields: [
          {
            fieldName: 'Will you have a mortgage?',
            field: 'hasMortgage',
            type:'radio',
            options: [
              { option:'Yes', value:true, icon:'Yes'},
              { option:'No', value:false, icon:'No'},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'hasMortgage');
              //why dont we just return true here
              return x.value === true || x.value === false;
            }
          },
          {
            fieldName: 'Do you know your mortgage amount?',
            field: 'hasMortgageAmount',
            type:'radio',
            options: [
              { option:'Yes', value:true, icon:'Yes'},
              { option:'No', value:false, icon:'No'},
            ],
            required: true,
            hide: (fields) => {
              // hides this field when the the hasMortgage field is not defined or is false
              let x = fields.find(x => x.field === 'hasMortgage');
              return typeof x.value === 'undefined' || !x.value;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'hasMortgage');
              let y = fields.find(x => x.field === 'hasMortgageAmount');
              return x.value === false || x.value === true && (y.value === true || y.value === false);
            }
          },
          {
            fieldName: 'Mortgage Amount',
            field: 'mortgageAmount',
            type:'currency',
            required: true,
            value: "0.00",
            smallField: true,
            hide: (fields) => {
              // hides this field when the the hasMortgageAmount field is not defined or is false
              let x = fields.find(x => x.field === 'hasMortgageAmount');
              let y = fields.find(x => x.field === 'hasMortgage');
              return (typeof x.value === 'undefined' || !x.value) || (y.value === 'undefined' || !y.value);
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'hasMortgage');
              let y = fields.find(x => x.field === 'hasMortgageAmount');
              let z = fields.find(x => x.field === 'mortgageAmount');
              return x.value === false || y.value === false || (x.value === true && y.value === true && this.NumberService.parseDecimal(z.value ? z.value : '') > 0);
            }
          },
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'ABOUT YOU',
        fields: [
          {
            fieldName: 'Is the purchaser a First Time Home Buyer?',
            field: 'isFirstTimeHomeBuyer',
            type:'radio',
            options: [
              { option:'Yes', value:true, icon:'Yes'},
              { option:'No', value:false, icon:'No'},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'isFirstTimeHomeBuyer');
              return x.value === true || x.value === false;
            }
          },
          {
            fieldName: 'Is the purchaser a foreign national?',
            field: 'isForeign',
            type:'radio',
            options: [
              { option:'Yes', value:true, icon:'Yes'},
              { option:'No', value:false, icon:'No'},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'isForeign');
              return typeof x.value !== 'undefined';
            }
          },
          {
            fieldName: 'Agreement signed after April 20, 2017?',
            field: 'isAgreementSignedAfterDate',
            type:'radio',
            options: [
              { option:'Yes', value:true, icon:'Yes'},
              { option:'No', value:false, icon:'No'},
            ],
            required: true,
            hide: (fields) => {
              // hides this field when the the isForeign field is not defined or is false
              let x = fields.find(x => x.field === 'isForeign');
              return typeof x.value === 'undefined' || !x.value;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'isAgreementSignedAfterDate');
              let y = fields.find(x => x.field === 'isForeign');
              if (y.value){
                return typeof x.value !== 'undefined';
              } else {
                return true;
              }
            }
          },
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'PROPERTY',
        fields: [
          {
            fieldName: 'Property in Toronto?',
            field: 'isPropertyInToronto',
            type:'radio',
            options: [
              { option:'Yes', value:true, icon:'Yes'},
              { option:'No', value:false, icon:'No'},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'isPropertyInToronto');
              return x.value === true || x.value === false;
            }
          },
          {
            fieldName: 'Home Type',
            field: 'homeType',
            type:'radio',
            options: [
              { option:'Freehold', value:'freehold', icon:'Freehold'},
              { option:'Condo', value:'condo', icon:'Condo'},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'homeType');
              return typeof x.value !== 'undefined' && x.value !== '';
            }
          },
          {
            fieldName: 'Home Age',
            field: 'homeAge',
            type:'radio',
            options: [
              { option:'Resale', value:'resale', icon:'Resale'},
              { option:'New Home', value:'new', icon:'New Home'},
            ],
            required: true,
            hide: (fields) => {
              return false;
            },
            isValid: (fields) => {
              let x = fields.find(x => x.field === 'homeAge');
              return typeof x.value !== 'undefined' && x.value !== '';
            }
          },
        ]
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'EMAIl',
        type:'email', // defines the type of page ( regular, email, end ). The default value is regular
        fields: []
      },
      { ///////////////////////////////////////////////////////////////////
        pageTitle:'CLOSING COST',
        type:'done', // defines the type of page ( regular, email, end ). The default value is regular
        fields: []
      }
    ];
  }
}

PurchaseController.$inject = ['NumberService'];

export default PurchaseController;



// WEBPACK FOOTER //
// ./client/app/components/purchase/purchase.controller.js